import { colors } from 'src/theme/adSales/colors'

export const borders = {
  tertiaryThin: `1px solid ${colors.border.tertiary}`,
  secondaryThin: `1px solid ${colors.border.secondary}`,
  primaryMedium: `4px solid ${colors.border.primary}`,
  tertiaryMediumHidden: `4px solid ${colors.background.tertiary}`,
  quaternaryMediumHidden: `4px solid ${colors.background.quaternary}`,
  primaryThick: `8px solid ${colors.border.primary}`,
  primaryThickHidden: `8px solid ${colors.background.primary}`,
  secondaryThick: `8px solid ${colors.border.secondary}`,
  secondaryThickHidden: `8px solid ${colors.background.secondary}`,
  tertiaryThick: `8px solid ${colors.border.tertiary}`,
  tertiaryThickHidden: `8px solid ${colors.background.tertiary}`,
  quaternaryThick: `8px solid ${colors.border.quaternary}`,
  quaternaryThickHidden: `8px solid ${colors.background.quaternary}`,
  boldError: `3px solid ${colors.state.error}`,
  activeButton: `0 0 0 2px #fff, 0 0 0 5px ${colors.state.active}`,
  hoverPageTab: `4px solid ${colors.border.secondary}`,
  hoverPageSelected: `4px solid ${colors.border.primary}`
}
